import { AutogenLayoutBankList } from "./autogen/AutogenLayoutBankList";

export class BankList extends AutogenLayoutBankList {
    onLoad(): void | Promise<void> {
        this.mainDataSource.search(null, null, this.layoutName);
    }
}
